module.exports = __webpack_public_path__ + "img/error-404.94756dcf.svg";